import React from 'react';
import { Button } from 'antd';
import type { FM121 } from '../../../services/pwm202Api';

interface DetailGridProps {
  details: Partial<FM121>[];
  isEditing: boolean;
  selectedIdx: number;
  onSelect: (idx: number) => void;
  onDetailChange: (idx: number, field: keyof FM121, value: unknown) => void;
  onAdd: () => void;
  onDelete: (idx: number) => void;
}

const DetailGrid: React.FC<DetailGridProps> = React.memo(({
  details,
  isEditing,
  selectedIdx,
  onSelect,
  onDetailChange,
  onAdd,
  onDelete,
}) => {
  return (
    <div className="detail-grid-wrapper">
      {isEditing && (
        <div className="detail-actions" style={{ marginBottom: 8 }}>
          <Button size="small" type="dashed" onClick={onAdd}>明細新增</Button>
        </div>
      )}
      <table className="detail-table">
        <thead>
          <tr>
            <th style={{ width: 40 }}>項次</th>
            <th style={{ width: 120 }}>出庫庫位</th>
            <th style={{ width: 100 }}>批號</th>
            <th style={{ width: 80 }}>產品代號1</th>
            <th style={{ width: 80 }}>產品代號2</th>
            <th style={{ width: 80 }}>移轉數量</th>
            <th style={{ width: 50 }}>單位</th>
            <th style={{ width: 60 }}>板號</th>
            <th style={{ width: 60 }}>等級</th>
            <th style={{ width: 130 }}>移轉原因</th>
            {isEditing && <th style={{ width: 50 }}>刪除</th>}
          </tr>
        </thead>
        <tbody>
          {details.map((d, idx) => (
            <tr
              key={idx}
              onClick={() => onSelect(idx)}
              style={{ background: selectedIdx === idx ? '#e6f4ff' : undefined, cursor: 'pointer' }}
            >
              <td>{(idx + 1)}</td>
              <td>
                {isEditing ? (
                  <input
                    value={d.fm121_11 ?? ''}
                    onChange={e => onDetailChange(idx, 'fm121_11', e.target.value)}
                    style={{ width: '100%' }}
                  />
                ) : d.fm121_11}
              </td>
              <td>
                {isEditing ? (
                  <input
                    value={d.fm121_12 ?? ''}
                    onChange={e => onDetailChange(idx, 'fm121_12', e.target.value)}
                    style={{ width: '100%' }}
                  />
                ) : d.fm121_12}
              </td>
              <td>
                {isEditing ? (
                  <input
                    value={d.fm121_13 ?? ''}
                    onChange={e => onDetailChange(idx, 'fm121_13', e.target.value)}
                    style={{ width: '100%' }}
                  />
                ) : d.fm121_13}
              </td>
              <td>
                {isEditing ? (
                  <input
                    value={d.fm121_14 ?? ''}
                    onChange={e => onDetailChange(idx, 'fm121_14', e.target.value)}
                    style={{ width: '100%' }}
                  />
                ) : d.fm121_14}
              </td>
              <td>
                {isEditing ? (
                  <input
                    type="number"
                    value={d.fm121_15 ?? 0}
                    onChange={e => onDetailChange(idx, 'fm121_15', parseFloat(e.target.value) || 0)}
                    style={{ width: '100%' }}
                  />
                ) : d.fm121_15}
              </td>
              <td>{d.fm121_17}</td>
              <td>
                {isEditing ? (
                  <input
                    value={d.fm121_20 ?? ''}
                    onChange={e => onDetailChange(idx, 'fm121_20', e.target.value)}
                    style={{ width: '100%' }}
                  />
                ) : d.fm121_20}
              </td>
              <td>{d.fm121_19}</td>
              <td>
                {isEditing ? (
                  <input
                    value={d.fm121_28 ?? ''}
                    onChange={e => onDetailChange(idx, 'fm121_28', e.target.value)}
                    placeholder="移轉原因"
                    style={{ width: '100%' }}
                  />
                ) : d.fm121_28}
              </td>
              {isEditing && (
                <td>
                  <Button
                    size="small"
                    danger
                    onClick={e => { e.stopPropagation(); onDelete(idx); }}
                  >
                    刪除
                  </Button>
                </td>
              )}
            </tr>
          ))}
          {details.length === 0 && (
            <tr><td colSpan={isEditing ? 11 : 10} style={{ textAlign: 'center', color: '#999' }}>無明細資料</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
});

export default DetailGrid;
